import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { observer } from 'mobx-react'

import {
  getDashboardButton,
  getDashboardHeader,
  getDashboardSubtitle,
} from 'Modules/dashboard/utils/dashboard.utils'

import { Banner } from 'Components/_theme'

import { useStore } from 'Stores/index'

import { useTheme } from 'Hooks'

import { isActiveLanguage } from 'Utilities'

import { SupportedLanguagesEnum } from 'Constants/locale'

import Img from 'Assets/images/dashboard/employee_banner.png'
import ImgTelekom from 'Assets/images/dashboard/employee_banner_telekom.png'

import type { DashboardEmployeeBannerProps } from './DashboardEmployeeBanner.types'

export const DashboardEmployeeBanner = observer(
  (props: DashboardEmployeeBannerProps) => {
    const { onNewOrderButtonClick, version } = props

    const { portalContentStore } = useStore()
    const { portalContent } = portalContentStore

    const intl = useIntl()

    const { isTelekomTheme } = useTheme()

    const isGermanLanguageActive = isActiveLanguage(SupportedLanguagesEnum.DE)

    const renderHeader = useMemo(() => {
      return getDashboardHeader(
        intl,
        isGermanLanguageActive,
        portalContent,
        'EmployeeDashboard_title',
      )
    }, [intl, portalContent, isGermanLanguageActive])

    const renderSubtitle = useMemo(() => {
      return getDashboardSubtitle(
        intl,
        isGermanLanguageActive,
        portalContent,
        'EmployeeDashboard_content',
      )
    }, [intl, portalContent, isGermanLanguageActive])

    const renderButton = useMemo(() => {
      return getDashboardButton(
        intl,
        isGermanLanguageActive,
        portalContent,
        'EmployeeDashboard_button',
      )
    }, [isGermanLanguageActive, portalContent, intl])

    const defaultImageSource = isTelekomTheme ? ImgTelekom : Img

    return (
      <Banner
        alt={
          portalContent?.dashboardImageURL
            ? renderSubtitle
            : intl.formatMessage({ id: 'Img_alt_dashboard_banner' })
        }
        badge={intl.formatMessage({ id: 'EmployeeDashboard_tag' })}
        buttonText={renderButton}
        className="mb-6 ps-0"
        imageSource={
          portalContent?.dashboardImageURL
            ? portalContent.dashboardImageURL
            : defaultImageSource
        }
        onButtonClick={onNewOrderButtonClick}
        showButton
        text={renderSubtitle}
        title={renderHeader}
        version={version}
      />
    )
  },
)
